import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtSectionButton from "../general/NtSectionButton";
import NtText from "../../../components/NtText";

function NtHomeConnectAtSeaSection(props) {
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View
        style={{
          backgroundColor: "#181818",
          borderRadius: 10,
          padding: 20,
          alignItems: "flex-start",
        }}
      >
        <NtSectionTitle style={{ textAlign: "left", fontWeight: "300" }}>
          STAY <NtText style={{ fontWeight: "800" }}>CONNECTED</NtText> AT{" "}
          <NtText style={{ fontWeight: "800" }}>SEA</NtText>
        </NtSectionTitle>
        <View
          style={{
            backgroundColor: "#3c3c3c",
            height: 1,
            width: "100%",
            marginTop: 20,
          }}
        />
        <NtSectionDescription style={{ marginTop: 20, color: "white" }}>
          NT Maritime helps cruise lines keep guests and crew connected with
          onboard calling, messaging, and high-speed internet — all through a
          branded app. Easy to use, fully integrated, and designed to feel just
          like home.
        </NtSectionDescription>

        <NtSectionButton
          containerStyle={{ marginTop: 35 }}
          color="white"
          title="Get a Demo"
          icon={"arrow-right"}
          onPress={() => {
            window.open("https://ntmaritime.com");
          }}
        />
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtHomeConnectAtSeaSection;
